import $ from 'jquery';
import '@mockup/func/globals/App.util';
import { App } from './App';

export const feedback = {
    init: function () {
        $('.feedback-module .feedback-module-caller').on('click', function () {
            $('.feedback-module .feedback-module-respond').stop().slideUp();

            var refUri = $('form[data-feedback-ajax="true"]').find('input[name = "RefererUri"]').val();

            if ($(this).hasClass('feedback-module-caller-approve')) {
                $('.feedback-module-respond-approve').stop().slideToggle();
                if (typeof window.ga === 'function') {
                    window.ga('send', 'event', 'ulogin', 'Feedback', 'Positiv_' + refUri);
                }
            } else {
                $('.feedback-module-respond-reject').stop().slideToggle();
                if (typeof window.ga === 'function') {
                    window.ga('send', 'event', 'ulogin', 'Feedback', 'Negativ_' + refUri);
                }
            }
        });

        $('form[data-feedback-ajax="true"]').submit(function () {
            var $form = $(this);

            $.ajax({
                url: $form.attr('action'),
                type: $form.attr('method'),
                data: $form.serialize()
            }).done(function () {
                var target = $form.attr('data-feedback-target');
                $(target).stop().slideToggle();
                $form.find('input[type=text], textarea, input[type=email]').val('');
                $('#divFeedback').slideUp();
                $('#divThanks').slideDown();
                var refererUri = $form.find('input[name = "RefererUri"]').val();
                var thumbsUp = $form.find('input[name = "Thumbsup"]').val();
                if (thumbsUp === 'true') {
                    if (typeof window.ga === 'function') {
                        window.ga('send', 'event', 'ulogin', 'Feedback', 'Positiv_Fritekst_Indsendt_' + refererUri);
                    }
                } else {
                    if (typeof window.ga === 'function') {
                        window.ga('send', 'event', 'ulogin', 'Feedback', 'Negativ_Fritekst_Indsendt_' + refererUri);
                    }
                }

            });
            return false;

        });
    }
};

export default feedback;

App.Util.feedback = feedback;
